/* Abrir anexos devolvidos pela API a partir de um object URL (um window.open
   direto ao endpoint dava 401, porque o token vai no cabeçalho). */

/* Tipos que o browser mostra por si. O resto (Office, zip, .msg) não ganha
   nada em abrir num separador: o browser descarregava à mesma, mas com um nome
   inventado a partir do object URL. */
const MOSTRAVEIS = /^(application\/pdf|image\/|text\/)/;

/* Abre o ficheiro se o browser o souber mostrar; senão descarrega-o com o nome
   certo. Usar isto sempre que o anexo possa ser de qualquer tipo. */
export function abrirOuDescarregar(resposta, nomeSugerido = '') {
    const tipo = tipoDaResposta(resposta, nomeSugerido);
    if (MOSTRAVEIS.test(tipo)) return abrirFicheiroDaResposta(resposta, nomeSugerido);

    const url = URL.createObjectURL(resposta.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeSugerido || 'anexo';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return null;
}

/* Descarrega sempre, com o nome dado (relatórios que se guardam, como os DL50),
   em vez de abrir num separador. */
export function descarregarBlob(dados, nome, tipo = 'application/pdf') {
    const blob = dados instanceof Blob ? dados : new Blob([dados], { type: tipo });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nome;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/* O tipo real da resposta: o do blob, o do cabeçalho, ou o que a extensão do
   nome disser quando os dois vêm genéricos. */
function tipoDaResposta(resposta, nomeSugerido = '') {
    const doCabecalho = String(resposta?.headers?.['content-type'] || '').split(';')[0].trim();
    const tipo = String(resposta?.data?.type || '').split(';')[0].trim() || doCabecalho;
    if (tipo && tipo !== 'application/octet-stream') return tipo;
    const ext = (nomeSugerido.match(/\.([a-z0-9]+)$/i) || [, ''])[1].toLowerCase();
    return {
        pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg',
        gif: 'image/gif', webp: 'image/webp', svg: 'image/svg+xml', txt: 'text/plain',
    }[ext] || tipo || 'application/octet-stream';
}

/* Abre sempre num separador novo. O tipo TEM de ir dentro do blob:
   `new Blob([r.data])` — sem `type` — produz um blob de tipo vazio e o browser
   mostra um PDF como texto ("%PDF-1.4 ... /Filter/DCTDecode"). O axios com
   responseType 'blob' já traz o tipo do Content-Type; o resto é rede de
   segurança para respostas sem tipo. */
export function abrirFicheiroDaResposta(resposta, nomeSugerido = '') {
    const tipo = tipoDaResposta(resposta, nomeSugerido);

    const blob = (resposta.data instanceof Blob && resposta.data.type === tipo)
        ? resposta.data
        : new Blob([resposta.data], { type: tipo });

    const url = URL.createObjectURL(blob);
    const janela = window.open(url, '_blank');
    // Libertar a memória do blob — mas só depois de o separador o ter lido.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return janela;
}
